<template>
  <div class="height-set-for-component">
     <div class="d-flex w-100" style="height:70px">
        <div class="search-bar-comm-style pt-2 col-md-8" style="display: block;">
          <input
            type="text"
            v-model="search"
            class="rounded text-light search-bar"
            :placeholder="$t('Search user group')"/>
        </div>
        <div class="primary-btn-style justify-content-end mr-3 pt-2 col-md-4">
          <!-- <button class="btn btn-outline-danger mr-2" style="border: 1px solid #831515;"  v-on:click="deleteUsergroupBtn()">Delete</button> -->
          <!-- <button class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;" v-on:click="editUserGroup('user-group-info')">Edit</button> -->
          <button class="btn btn-outline-primary m-2"  v-on:click="changeComponent('add-user-group')">{{$t('Add')}}</button>
        </div>
        </div>
    <div class="pl-4 pt-0 pr-4 pb-2" style="width: 100% !important;overflow:auto;height:calc(100% - 70px)">
      <table
        class="table-with-border table-scroll small-first-col"
        style="background: transparent">
        <thead style="color: #eee">
          <tr>
            <th style="width: 30%" class="text-left">{{$t('Group Name')}}</th>
            <th style="width: 30%" class="text-left">{{$t('User(s)')}}</th>
            <th style="width: 2%"></th>
          </tr>
        </thead>
        <tbody class="body-half-screen">
          <tr v-for="userGroup in filteredUserGroups" :key="userGroup._id" :id="userGroup._id" 
          @click="selectRow(userGroup), changeComponent('user-group-info', userGroup)"
            :class="{activeclass: activeRow == userGroup._id}"
          class="comm-user-row show-delete-icon">
          <!-- @dblclick="changeComponent('user-group-info', userGroup)"  -->
            <td  class="text-left" style="display: flex;justify-content: flex-start;align-items: center;">
              {{userGroup.group_name}}
            </td>
            <td class="text-left p-0 d-flex">
              <div v-for="name in getGroupUserNames(userGroup)" :key="name" class='d-flex'>
              <div v-if="Object.keys(name).includes('profile_image') && !['undefined',null].includes(name.profile_image) && name.profile_image" class='user-name-or-image'>
                  <img :src="getProxyConvertedURL(name.profile_image)" :title="name.username" @error="replaceWithUserIcon($event,name.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
              </div>
              <div v-else class="user-name-or-image" :title="name.username" :style="style(name.username)" >{{name.username.split("")[0]}}</div>
                </div></td>
            <td style="position: relative">
              <!-- <div class="dropdown">
                <div
                  class="nav-item nav-link dropdown-toggle mr-md-2"
                  id="bd-versions"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <svg
                    width="2em"
                    height="1.5em"
                    viewBox="0 0 16 16"
                    class="bi bi-three-dots more-actions-btn"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                    />
                  </svg>
                </div>
                <div
                  class="dropdown-menu dropdown-menu-md-right p-0"
                  aria-labelledby="bd-versions"
                >
                  <a
                    class="dropdown-item p-2"
                    @click.stop.prevent="deleteUserGroup(userGroup._id, userGroup.group_name)"
                  >
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 16 16"
                      class="bi bi-trash-fill"
                      style="margin-inline-end: 4px"
                      fill="#c5c0c0"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"
                      />
                    </svg>
                    Delete</a
                  >
                </div>
              </div> -->
              <svg  @click.stop.prevent="changeComponent('user-group-info', userGroup)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-pencil parent-row-edit user-actions-icon" viewBox="0 0 16 16">
                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
              </svg>
              <svg @click.stop.prevent="deleteUserGroup(userGroup._id, userGroup.group_name)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-trash parent-row-delete user-actions-icon" viewBox="0 0 16 16">
                  <title>{{$t('Delete')}}</title>
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                  <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
              </svg>
            </td>
          </tr>
       </tbody>
      </table>
    </div>
     <div>
    <pagination
        v-model="page"
        :records="totalUserGroups"
        :per-page="perPage"
        @paginate="paginate"
        :options="options"
    />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Utils from "../../components.utils.js";
import Pagination from "vue-pagination-2";
import { NotifierConstants } from "../../components.constants";


export default {
  props: ["userGroupId"],
  data() {
    return {
      currentPage:1,
      page: 1,
      isHidden: null,
      search: null,
      totalPages: -1,
      totalUserGroups: -1,
      perPage: -1,
      userGroupsData:[],
      options:{chunk:5},
      selectedRowDetails:{},
      activeRow:null,
      userNameIdMap:[],
      userGroupsList: []
    };
  },
  components:{
    pagination: Pagination,
  },
  emits: ["changeSelectedComponent"],
  methods: {
    getProxyConvertedURL(url){
        return Utils.convertToLoginIPDomainName(url);
    },
    getProfileImageOfUser(image){
      let defaultImage = Utils.getNoThumbnailImg()
        let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
        return profileImageTag;
    },
    replaceWithUserIcon(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },
    getGroupUserNames(userGroup){
      // User_list checked moved here, to handle the groups not having user_list
      let userIdList = []
      if(userGroup && userGroup.user_list){
        userIdList = userGroup.user_list
      }
      let userNameList = []
      if(userIdList != undefined && this.userNameIdMap != undefined && userIdList.length){
        for (var i=0 ;i < this.userNameIdMap.length; i++){
          if(userIdList.indexOf(this.userNameIdMap[i].user_id) > -1){
            userNameList.push(this.userNameIdMap[i])
          }
        }
        return userNameList
      }else if(userIdList.length == 0){
        return ""
      }
    },
    style(name){
      let style = {
        'color':this.textColor(this.intToRGB(this.hashCode(name))),
        'background-color':'#'+this.intToRGB(this.hashCode(name))
      }
      return style
    },
    hashCode(str) { // java String#hashCode
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    },
    intToRGB(i){
        var c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();

        return "00000".substring(0, 6 - c.length) + c;
    },
    textColor(hexcolor){
      // If a leading # is provided, remove it
      if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
      }

      // Convert to RGB value
      var r = parseInt(hexcolor.substr(0,2),16);
      var g = parseInt(hexcolor.substr(2,2),16);
      var b = parseInt(hexcolor.substr(4,2),16);

      // Get YIQ ratio
      var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

      // Check contrast
      return (yiq >= 128) ? 'black' : 'white';

    },
    paginate(page) {
      this.page = page; 
      this.updateUserGroupsList();
    },
    changeComponent(comp, userGroupInfo={}){
      this.$emit("changeSelectedComponent", comp, userGroupInfo);
    },
    editUserGroup(comp){
      if(this.selectedRowDetails._id != undefined){
        this.changeComponent(comp,this.selectedRowDetails)
      }else{
        alert("Select User Group to edit");
        return false;
      }
    },
    deleteUsergroupBtn(){
      if(this.activeRow != undefined){
        this.deleteUserGroup(this.selectedRowDetails._id,this.selectedRowDetails.group_name)
      }else{
        alert("Select User Group to delete");
        return false;
      }
    },
    selectRow(key){
      this.selectedRowDetails = key;
      this.activeRow = key._id;
    },
    deleteUserGroup(groupId, userGroupName) {
      if (
        confirm(
          `Are You sure you want to delete the selected "${userGroupName}" group ? `
        )
      ) {
        this.deleteExistingUserGroup({ _id: groupId }).then((data) => {
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message);
          }
        });
        this.updateUserGroupsList();
        this.selectedRowDetails = {}
      }
    },
    updateUserGroupsList() {
      let payload = {};
      payload.params = { page: this.page};
      this.getAllUserGroupsFromServer(payload).then((data) => {
        this.totalPages = data["page_count"];
        this.page = data["page"];
        this.totalUserGroups = data["total_user_groups"];
        this.perPage = data["user_groups_per_page"];
        if ("user_groups" in data) {
          this.userGroupsList = data.user_groups;
          this.userNameIdMap = data.user_map;
        }
        this.selectedRowDetails = {}
      });
    },
    handleUserGroupsNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let group_info = notification.message;
        if(group_info){
          if('user_map' in group_info){
            for(let eachMap of group_info.user_map){
              let idx = this.userNameIdMap.findIndex(op=>op.user_id == eachMap.user_id)
              if(idx < 0){
                this.userNameIdMap.push(eachMap)
              }
            }
          }
          if(notification.message_type == NotifierConstants.userGroupCreatedNotification){
            this.userGroupsList.unshift(group_info)
            this.totalUserGroups += 1;
          }else {
            let indx = this.userGroupsList.findIndex(op=>op._id==group_info._id)
            if(indx >= 0){
              if(notification.message_type == NotifierConstants.userGroupRemovedNotification){
                this.userGroupsList.splice(indx,1)
                this.totalUserGroups -= 1;
              }else if(notification.message_type == NotifierConstants.userGroupModifiedNotification){
                this.$set(this.userGroupsList[indx], "user_list", group_info.user_list);
                this.$set(this.userGroupsList[indx], "group_name", group_info.group_name);
              }
            }
          }
        }
      }
    },
    handleUsersNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let userInfo = notification.message
      if(userInfo){
        if([NotifierConstants.userRemovedNotification].includes(notification.message_type)){
          this.userNameIdMap = this.userNameIdMap.findIndex(op=>op.user_id != userInfo._id)
          for(let eachGroup of this.userGroupsList){
            if(eachGroup.user_list.includes(userInfo._id)){
              let updatedUserList = eachGroup.user_list.filter(op=>op!=userInfo._id)
              this.$set(this.userGroupsList[this.userGroupsList.findIndex(op=>op._id==eachGroup._id)], "user_list", updatedUserList)
            }
          }
        }
      }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[NotifierConstants.userGroupCreatedNotification, NotifierConstants.userGroupModifiedNotification, NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserGroupsNotification,
            parent:"ShowUserGroups"})
      this.addWSEventListener({
            eventname:[NotifierConstants.userRemovedNotification],
            callback:this.handleUsersNotification,
            parent:"ShowUserGroups"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[NotifierConstants.userGroupCreatedNotification, NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserGroupsNotification,
            parent:"ShowUserGroups"})
      this.removeWSEventListener({
            eventname:[NotifierConstants.userRemovedNotification],
            callback:this.handleUsersNotification,
            parent:"ShowUserGroups"})
    },
    ...mapActions("userGroups", ["getAllUserGroupsFromServer", "deleteExistingUserGroup"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"])
  },
  created() {
    this.updateUserGroupsList();
    this.registerforWebsocketNotifications();
  },
  computed:{
    filteredUserGroups(){
      if(this.search != null){
        if (!this.userGroupsList.length) {
            return [];
          }
          return this.userGroupsList.filter((item) => {
            const userGroupName = item.group_name.toLowerCase();
            const searchTerm = this.search.toLowerCase();
            return userGroupName.includes(searchTerm);
          });
        }else{
          return this.userGroupsList;
      }
    },
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  },
};
</script>


<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;


.activeclass {
  color: $active-blue;
}

.table-scroll {
  /*width:100%; */
  height: 100%;
  display: block;
  empty-cells: show;
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  border: 1px solid;
  thead {
    color: $dull-text-color !important;
    position: relative;
    display: block;
    width: 100%;
  }
  tbody {
    height:100%;
    display: block;
    position: relative;
    width: 100%;
    overflow: auto;
    font-weight: 500;
    max-height: calc(100vh - 250px);
  }
}

.table-scroll tr {
  width: 100%;
  display: flex;
  // min-height: 50px;
}

.table-scroll td,
.table-scroll th {
  flex-basis: 100%;
  flex-grow: 2;
  justify-content: flex-start;
  flex-flow: wrap;
}

.body-half-screen {
  max-height: 50vh;
}

.small-col {
  flex-basis: 10%;
}

.comm-user-row:hover {
  background: $bg-color-on-hover;
  color: $active-blue;
  td:first-child {
    text-decoration: underline;
  }
}

.height-set-for-component {
  height: calc(100% - 95px);
}

table .more-actions-btn {
  visibility: hidden;
}
table tr:hover .more-actions-btn {
  visibility: visible;
}

.search-bar-comm-style {
  margin-top: 5px;
  .search-bar{
    background: $primary-background!important;
    height:38px;
    width: 250px !important;
    float: inline-start;
    padding-inline-start: 12px;
    margin: 0;
    margin-inline-end: 3%;  
    padding-bottom:2px;
    border: $border-color !important;
  }
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 9px;
    margin-inline-end: -7px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.activestatus {
  color: #28a745 !important;
}

.show-delete-icon:hover{
    position: relative;
    .parent-row-delete,  .parent-row-edit, .parent-row-logout{
        visibility: visible;
    }
}

.parent-row-delete, .parent-row-edit, .parent-row-logout{
    margin-inline-start: 3px;
    // position: absolute;
    // inset-inline-end :0px;
    z-index: 1;
    background: #525252 !important;
    border: 1px solid #262626 !important; 
    width: 55px;
    height: 44px;
    padding: 12px;
    top: 0px;
    border-radius: 4px;
    visibility: hidden;
    color: #fff !important;
}


::v-deep {
        .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float: inline-end;
            margin-inline-start: 5px;
            position: relative;
            top:5px;
        }
.VuePagination__pagination-item {
    font-size: 14px;
    width: 27px;
}
.VuePagination__pagination-item-prev-chunk {
  display:none;
}
.VuePagination__pagination-item-next-chunk{
  display:none;
}

.VuePagination__pagination-item-prev-page{
  width:50px !important;
}

.VuePagination__pagination-item-next-page{
  width:50px !important;
}

.VuePagination__pagination-item-next-page a:before{
  width:50px;
  content: "next ";
}

.VuePagination__pagination-item-prev-page a:after{
  width:50px;
  content: " prev";
}
.v-list{
  padding:0px !important;
}
.v-list-item{
  text-align: start;
  border: $border-color !important;
  min-height: 37px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
    .v-list-item__title{
          font-size: 14px !important;
          color:$text-color !important;
    }
  }
.v-menu__content{
  width:150px !important;
}
}
.primary-btn-style{
    width: 100%;
    text-align: end;
    button{
      height: 38px;
      width: 70px;
      font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}
</style>
